export const GET_DASHBOARD_ALL_FOLLOWINGS = 'GET_DASHBOARD_ALL_FOLLOWINGS';
export const GET_DASHBOARD_ALL_FOLLOWINGS_PENDING = 'GET_DASHBOARD_ALL_FOLLOWINGS_PENDING';
export const GET_DASHBOARD_ALL_FOLLOWINGS_FULFILLED = 'GET_DASHBOARD_ALL_FOLLOWINGS_FULFILLED';
export const GET_DASHBOARD_ALL_FOLLOWINGS_REJECTED = 'GET_DASHBOARD_ALL_FOLLOWINGS_REJECTED';
